import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { theme } from '../theme';

export const StyledFooter = styled.footer`
  background-color: ${({theme}) => theme.colors.primaryK9};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > * {
    padding: 0 0.9375rem;
  }

  ${mediaQuery('md')} {
    & > * {
      padding: 0 2rem;
    }
  }
`;
